import { getMidpointGrowingDate, useGetFarmFieldListAtPointInTime, useGetFields, useGetPracticeCrops } from "utils";

/**
 * Total hectares of the given fields, looked up like the crop field selection step does:
 * the field list at the crop's midpoint growing date, falling back to the current fields.
 */
export const useGetCropFieldHectares = ({ farmId, cropId, year, fieldIds }: { farmId: string; cropId: string; year: number; fieldIds: string[] }): number => {
  const { data: allFields } = useGetFields({ farmId });
  const regionId = allFields?.find((field) => field.regionId)?.regionId;
  const { data: practiceCrops } = useGetPracticeCrops({ regionId, enabled: !!regionId && !!allFields });
  const midpointDateForYear = getMidpointGrowingDate(practiceCrops?.find((crop) => crop.id === cropId), year);
  const { data: fieldListAtPointInTime } = useGetFarmFieldListAtPointInTime({ farmId, date: midpointDateForYear.toISOString() });

  const fieldList = fieldListAtPointInTime?.length ? fieldListAtPointInTime : allFields;

  return fieldIds.reduce((totalHa, fieldId) => totalHa + (fieldList?.find((field) => field.id === fieldId)?.size ?? 0), 0);
};
